import { HPCSection } from './hpc_section';

export class HPCReport {
  constructor({
    id = null,
    classes = [],
    name,
    sections = [],
    gender = null,
    studentName = '',
    profileImage = null,
    fatherName = null,
    guardianName = null,
    overallSummary = null,
    dob = null,
    Class,
    sec,
    primaryColor,
    secondaryColor,
    accentColor,
    academicYear
  }) {
    this.id = id;
    this.classes = classes;
    this.name = name;
    this.sections = sections;
    this.gender = gender;
    this.studentName = studentName;
    this.profileImage = profileImage;
    this.fatherName = fatherName;
    this.guardianName = guardianName;
    this.overallSummary = overallSummary;
    this.dob = dob;
    this.Class = Class;
    this.sec = sec;
    this.primaryColor = primaryColor;
    this.secondaryColor = secondaryColor;
    this.accentColor = accentColor;
    this.academicYear = academicYear;
  }

  static fromJSON(json) {
    let dobDate;
    if(json.dob){
      dobDate = json.dob.toDate();
    }
    return new HPCReport({
      id: json.id,
      classes: json.classes || [],
      name: json.name || '',
      Class: json.Class || null,
      academicYear: json.academicYear || null,
      sec: json.sec || null,
      sections: (json.sections || []).map(section => 
        HPCSection.fromJSON(section)
      ),
      gender: json.gender || null,
      studentName: json.studentName || '',
      profileImage: json.profileImage || null,
      fatherName: json.fatherName || null,
      guardianName: json.guardianName || null,
      dob: dobDate || null,
      primaryColor: json.primaryColor || null,
      secondaryColor: json.secondaryColor || null,
      accentColor: json.accentColor || null,
      overallSummary: json.overallSummary || null
    });
  }

  updateSection(section) {
    const index = this.sections.findIndex(item => item.id === section.id);
    if (index !== -1) {
      this.sections[index] = section;
    }
  }

  addSection(section) {
    // Assign an ID to the section based on its position in the list
    const newId = this.sections.length === 0 ? 0 : this.sections.length;
    const newSection = new HPCSection({
      id: newId,
      title: section.title,
      objective: section.objective,
      learningOutcomes: section.learningOutcomes
    });
    this.sections.push(newSection);
  }

  removeSection(section) {
    const index = this.sections.findIndex(item => item.id === section.id);
    if (index !== -1) {
      this.sections.splice(index, 1);
    }
  }

  toJSON() {
    return {
      id: this.id,
      classes: this.classes,
      name: this.name,
      sections: this.sections.map(section => section.toJSON()),
      gender: this.gender,
      studentName: this.studentName,
      profileImage: this.profileImage,
      fatherName: this.fatherName,
      guardianName: this.guardianName,
      dob: this.dob
    };
  }
}